export const SET_DATA = 'reports/SET_DATA'
export const SET_FIELDS = 'reports/SET_FIELDS'
export const SET_IS_FETCHING = 'reports/SET_IS_FETCHING'
